module.exports = __webpack_public_path__ + "officialStatic/img/tbz.c5bbdee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tbz.png
// module id = 2Yow
// module chunks = 0